package fr.frux.feature.support

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [SupportPromptViewModel], honoré par le composition root (#43). */
fun interface SupportPromptViewModelFactory {
    fun create(): SupportPromptViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalSupportPromptViewModelFactory =
    staticCompositionLocalOf<SupportPromptViewModelFactory> {
        error(
            "SupportPromptViewModelFactory absente : le composition root doit l'installer " +
                "(cf. FruxCompositionRoot, #43)",
        )
    }

/** Fabrique le SupportPromptViewModel depuis la fabrique fournie par le root. */
@Composable
fun rememberSupportPromptViewModel(): SupportPromptViewModel {
    val factory = LocalSupportPromptViewModelFactory.current
    return viewModel { factory.create() }
}
